<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Cabinet Features</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (drainPanSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Drain Pan:</label>
            <select class="halfWidthInputField" #drainPanInput
              [class.invalidConfigurationSelection]="isInvalidSelection(drainPanSelection.Name)"
              (change)="selectionChanged(drainPanSelection, drainPanInput.value)"
              [value]="drainPanSelection.Value.toString()">
              @for (allowable of drainPanSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="drainPanSelection.Value && drainPanSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (cabinetHeightSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Cabinet Height:</label>
            <select class="halfWidthInputField" #cabinetHeightInput
              [class.invalidConfigurationSelection]="isInvalidSelection(cabinetHeightSelection.Name)"
              (change)="selectionChanged(cabinetHeightSelection, cabinetHeightInput.value)"
              [value]="cabinetHeightSelection.Value.toString()">
              @for (allowable of cabinetHeightSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="cabinetHeightSelection.Value && cabinetHeightSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (cabinetInsulationSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Cabinet Insulation:</label>
            <select class="halfWidthInputField" #cabinetInsulationInput
              [class.invalidConfigurationSelection]="isInvalidSelection(cabinetInsulationSelection.Name)"
              (change)="selectionChanged(cabinetInsulationSelection, cabinetInsulationInput.value)"
              [value]="cabinetInsulationSelection.Value.toString()">
              @for (allowable of cabinetInsulationSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="cabinetInsulationSelection.Value && cabinetInsulationSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (cabinetUpsizingSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Cabinet Upsizing:</label>
            <select class="halfWidthInputField" #upsizingInput
              [class.invalidConfigurationSelection]="isInvalidSelection(cabinetUpsizingSelection.Name)"
              (change)="selectionChanged(cabinetUpsizingSelection, upsizingInput.value)"
              [value]="cabinetUpsizingSelection.Value.toString()">
              @for (allowable of cabinetUpsizingSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="cabinetUpsizingSelection.Value && cabinetUpsizingSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        <span class="halfWidthConfigurationInput"></span>
        @if (riserChaseSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Riser Chase:</label>
            <select class="halfWidthInputField" #riserChaseInput
              [class.invalidConfigurationSelection]="isInvalidSelection(riserChaseSelection.Name)"
              (change)="selectionChanged(riserChaseSelection, riserChaseInput.value)"
              [value]="riserChaseSelection.Value.toString()">
              @for (allowable of riserChaseSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="riserChaseSelection.Value && riserChaseSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
    </div>
  }
</div>
